export const CONFIRMED_GET_PROPERTY_SUMMARY = '[Report Action] Confirmed Get Property Summary';
export const CONFIRMED_GET_PROPERTY_COUNT_BY_MONTH = '[Report Action] Confirmed Get Property Count By Month';
export const CONFIRMED_GET_PROPERTY_COUNT_BY_STATE = '[Report Action] Confirmed Get Property Count By State';
export const CONFIRMED_GET_PROPERTY_COUNT_BY_DISTRICT = '[Report Action] Confirmed Get Property Count By District';
